import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signIn',
    name: 'sign-in-page',
    component: require('@/views/SignInPage').default,
    meta: { title: 'サインイン - キーボードリル' }
  },
  {
    path: '/resetPassword',
    name: 'reset-password-page',
    component: require('@/views/ResetPasswordPage').default,
    meta: { title: 'パスワードリセット - キーボードリル' }
  },
  {
    path: '/',
    name: 'top-page',
    component: require('@/views/TopPage').default,
    meta: { title: 'キーボードリル' }
  },
  {
    path: '/lesson/select',
    name: 'lesson-select-page',
    component: require('@/views/LessonSelectPage').default,
    meta: { title: '基本レッスンメニュー - キーボードリル' }
  },
  {
    path: '/lesson/player/:areaId/:stageId',
    name: 'lesson-player-page',
    component: require('@/views/LessonPlayerPage').default,
    meta: { title: '基本レッスン - キーボードリル' }
  },
  {
    path: '/routine/top',
    name: 'routine-top-page',
    component: require('@/views/RoutineTopPage').default,
    meta: { title: 'ルーティーンメニュー - キーボードリル' }
  },
  {
    path: '/routine/player',
    name: 'routine-player-page',
    component: require('@/views/RoutinePlayerPage').default,
    meta: { title: 'ルーティーン - キーボードリル' }
  },
  {
    path: '/routine/result',
    name: 'routine-result-page',
    component: require('@/views/RoutineResultPage').default,
    meta: { title: 'ルーティーン - キーボードリル' }
  },
  {
    path: '/speedUp/select',
    name: 'speedup-select-page',
    component: require('@/views/SpeedUpSelectPage').default,
    meta: { title: 'スピードアップゲーム - キーボードリル' }
  },
  {
    path: '/challenge/',
    name: 'challenge-top-page',
    component: require('@/views/ChallengeTopPage').default,
    meta: { title: '測定チャレンジメニュー - キーボードリル' }
  },
  {
    path: '/challenge/player',
    name: 'challenge-player-page',
    component: require('@/views/ChallengePlayerPage').default,
    meta: { title: '測定チャレンジ - キーボードリル' }
  },
  {
    path: '/challenge/result',
    name: 'challenge-result-page',
    component: require('@/views/ChallengeResultPage').default,
    meta: { title: '測定チャレンジ結果 - キーボードリル' }
  },
  {
    path: '/customize/',
    name: 'customize-top-page',
    component: require('@/views/CustomizeTopPage').default,
    meta: { title: '設定 - キーボードリル' }
  },
  {
    path: '/speedup/rakugo',
    name: 'speedup-rakugo-page',
    component: require('@/views/speedUp/rakugo/RakugoTopPage').default,
    meta: { title: '噺家への道メニュー - キーボードリル' }
  },
  {
    path: '/speedup/rakugo/select',
    name: 'speedup-rakugo-select-page',
    component: require('@/views/speedUp/rakugo/RakugoSelectPage').default,
    meta: { title: '噺家への道メニュー - キーボードリル' }
  },
  {
    path: '/speedup/rakugo/player/:level',
    name: 'speedup-rakugo-player-page',
    component: require('@/views/speedUp/rakugo/RakugoPlayerPage').default,
    meta: { title: '噺家への道 - キーボードリル' }
  },
  {
    path: '/speedup/rakugo/result/:level',
    name: 'speedup-rakugo-result-page',
    component: require('@/views/speedUp/rakugo/RakugoResultPage').default,
    meta: { title: '噺家への道結果 - キーボードリル' }
  },
  {
    path: '/embedded/trial-complete',
    name: 'trial-complete-page',
    component: require('@/views/TrialCompletePage').default,
    props: {
      embedded: true
    },
    meta: { title: 'お試しレッスン完了 - キーボードリル' }
  },
  {
    path: '/embedded/challenge/',
    name: 'embedded-challenge-top-page',
    component: require('@/views/ChallengeTopPage').default,
    props: {
      embedded: true
    },
    meta: { title: '測定チャレンジ - キーボードリル' }
  },
  {
    path: '/embedded/challenge/player',
    name: 'embedded-challenge-player-page',
    component: require('@/views/ChallengePlayerPage').default,
    props: {
      embedded: true
    },
    meta: { title: '測定チャレンジ - キーボードリル' }
  },
  {
    path: '/embedded/challenge/result',
    name: 'embedded-challenge-result-page',
    component: require('@/views/ChallengeResultPage').default,
    props: {
      embedded: true
    },
    meta: { title: '測定チャレンジ結果 - キーボードリル' }
  },
  {
    path: '/embedded/lesson/player/:lessonId',
    name: 'embedded-lesson-player-page',
    component: require('@/views/LessonPlayerPage').default,
    props: {
      embedded: true
    },
    meta: { title: 'お試しレッスン - キーボードリル' }
  },
  {
    path: '*',
    redirect: '/signIn'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/signIn') {
    next()
  } else if (to.path === '/resetPassword') {
    next()
  } else {
    // firebase.auth().onAuthStateChanged(user => {
    const isEmbedded = to.path.indexOf('/embedded/') === 0
    if (store.state.User.isSignIn || isEmbedded) {
      next()
    } else {
      console.log('未認証')
      next({ path: '/signIn' })
    }
    if (to.meta.title) {
      document.title = to.meta.title
    }
  }
})

export default router
